import { useEffect, useState } from "react";
import { setConsent, track } from "../lib/tracking";

export default function ConsentBanner() {
  const [sichtbar, setSichtbar] = useState(() => {
    try {
      return localStorage.getItem("2bs_consent") === null;
    } catch (e) {
      return false;
    }
  });

  useEffect(() => {
    function oeffnen() {
      setSichtbar(true);
    }
    window.addEventListener("2bs-cookieeinstellungen", oeffnen);
    return () => window.removeEventListener("2bs-cookieeinstellungen", oeffnen);
  }, []);

  if (!sichtbar) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 mx-auto max-w-xl rounded-[2px] border border-navy/10 bg-white p-6 shadow-[0_24px_60px_-30px_rgba(15,35,60,0.4)]" data-testid="cookie-banner">
      <p className="text-sm leading-[1.8] text-textdunkel">
        Wir verwenden den Meta Pixel, um unsere Werbung zu messen. Cookies werden dabei erst nach Ihrer Einwilligung gesetzt. Details finden Sie in unserer Datenschutzerklärung.
      </p>
      <div className="mt-5 flex flex-wrap gap-3">
        <button
          type="button"
          data-testid="cookie-akzeptieren"
          onClick={() => {
            setConsent(true);
            setSichtbar(false);
            track("PageView");
          }}
          className="rounded-[2px] bg-gruen px-6 py-3 text-xs font-semibold uppercase tracking-[0.12em] text-white transition-all duration-300 hover:bg-gruenhover"
        >
          Akzeptieren
        </button>
        <button
          type="button"
          data-testid="cookie-ablehnen"
          onClick={() => {
            setConsent(false);
            setSichtbar(false);
          }}
          className="rounded-[2px] border border-navy/20 px-6 py-3 text-xs font-semibold uppercase tracking-[0.12em] text-textgrau transition-colors duration-300 hover:border-navy hover:text-textdunkel"
        >
          Ablehnen
        </button>
      </div>
    </div>
  );
}